import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'flex',
  'flex-col',
  'mr-2',
  'ml-2',
  'mb-2',
  'gap-2'
);

interface Props {
  children: ReactNode;
}

const CardFooter = ({ children }: Props) => (
  <div className={className}>{children}</div>
);

export default CardFooter;
